/**
 * Pin Google Merchant "Top Quality Store" badge just above the sticky
 * footbar Add to Cart button. Google sets inline !important left/bottom on
 * #google-merchantwidget-iframe-wrapper, so we re-apply via JS.
 */
(function () {
  var ID = 'google-merchantwidget-iframe-wrapper';
  var BUTTON_SEL = '.js-footbar-product.footbar-product--visible .footbar-product__button-add-to-cart .btn--footbar, .js-footbar-product.footbar-product--visible .btn--footbar';
  var BADGE_SIZE = 56;
  var GAP = 8;
  var applying = false;
  var lastLeft = '';
  var lastBottom = '';
  var raf = 0;
  var obs = null;
  var observed = null;

  function isVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
      return false;
    }
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function getAnchorButton() {
    return document.querySelector(BUTTON_SEL);
  }

  function computePosition(button) {
    var rect = button.getBoundingClientRect();
    var left = Math.round(rect.left + rect.width / 2 - BADGE_SIZE / 2);
    var maxLeft = Math.max(8, window.innerWidth - BADGE_SIZE - 8);
    left = Math.min(Math.max(8, left), maxLeft);
    var bottom = Math.round(window.innerHeight - rect.top + GAP);
    bottom = Math.max(GAP, bottom);
    return {
      left: left + 'px',
      bottom: bottom + 'px'
    };
  }

  function apply(el, left, bottom) {
    if (!el || applying) return;
    if (left === lastLeft && lastBottom === bottom &&
        el.style.getPropertyValue('left') === left &&
        el.style.getPropertyValue('bottom') === bottom) {
      return;
    }
    applying = true;
    el.style.setProperty('left', left, 'important');
    el.style.setProperty('bottom', bottom, 'important');
    lastLeft = left;
    lastBottom = bottom;
    applying = false;
  }

  function observeBadge(badge) {
    if (observed === badge) return;
    if (obs) obs.disconnect();
    observed = badge;
    obs = new MutationObserver(schedule);
    obs.observe(badge, { attributes: true, attributeFilter: ['style', 'class'] });
    var footbar = document.querySelector('.js-footbar-product');
    if (footbar) obs.observe(footbar, { attributes: true, attributeFilter: ['class'] });
  }

  function run() {
    var badge = document.getElementById(ID);
    if (!badge) return;
    observeBadge(badge);

    var button = getAnchorButton();
    if (!isVisible(button)) return;

    var pos = computePosition(button);
    apply(badge, pos.left, pos.bottom);
  }

  function schedule() {
    if (raf) return;
    raf = window.requestAnimationFrame(function () {
      raf = 0;
      run();
    });
  }

  run();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  }

  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('scroll', schedule, { passive: true });
})();
